import { Component, Input } from '@angular/core';
import { AbstractControl, AbstractControlDirective } from '@angular/forms';

@Component({
    selector: 'field-error-component',
    templateUrl: 'field-error.component.html',
    styleUrls: ['field-error.component.scss']
})

export class FieldErrorComponent {
  
  errorMsgList: any = [];
  
  @Input() controlName: AbstractControl | AbstractControlDirective;
  @Input() formSubmitted: boolean;
  
  errorMessage = {
    'required'  : (params)  => `This field is required`,
    'maxlength' : (params)  => `Maximum ${params.requiredLength} characters are allowed`,
    'minlength' : (params)  => `Minimum ${params.requiredLength} characters are required`,
    'pattern'   : (params)  => `Invalid format`,
    'max'       : (params)  => `Maximum should be ${params.max}`,
    'min'       : (params)  => `Minimum should be ${params.min}`,
    'matDatetimePickerMin'       : (params)  => `Minimum Date should be ${params.min}`,
    'whitespace': (params)   => `White spaces are not allowed`,
    'email': (params)   => `Please enter valid Email`,
  };

  listErrors() {
    if (!this.controlName) return [];
    if (this.controlName.errors) {
      this.errorMsgList = [];
      Object.keys(this.controlName.errors).map( error => {
        // console.log('error',error);
        this.controlName.touched || this.controlName.dirty || this.formSubmitted ?
        this.errorMsgList.push(this.errorMessage[error](this.controlName.errors[error])) : '';
      });
      return this.errorMsgList;
    }
    else {
        return [];
    }
  }
}